import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import ContentBox from "../ContentBox/ContentBox.tsx";
import ExecutionJobStepRow from "./ExecutionJobStepRow.tsx";
import { ExecutionJob } from "../../types/ExecutionJob/ExecutionJob.ts";

type ExecutionJobStepsTableProps = {
  executionJob: ExecutionJob;
};

const ExecutionJobStepsTable = ({ executionJob }: ExecutionJobStepsTableProps) => (
  <ContentBox headline={"Schritte"}>
    {executionJob.steps.length === 0 ? (
      <Typography>Dieser Job enthält keine Schritte.</Typography>
    ) : (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Action</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Ausgeführt</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {executionJob.steps.map((step) => (
              <ExecutionJobStepRow key={step.id} step={step} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </ContentBox>
);

export default ExecutionJobStepsTable;
